import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function FlowButton ({onClick, name}) {
    
    return <button className='baseElementsconfirmButton' onClick={onClick}>{name}</button>
}

export default FlowButton;